import { wei } from '@kwenta/wei'
import { memo } from 'react'

import {
	selectCrossMarginTradePreview,
	selectV3SelectedMarketInfo,
} from 'state/futures/snxPerpsV3/selectors'
import { useAppSelector } from 'state/hooks'
import FeeRows from './FeeRows'

const CrossMarginTradeFees = memo(({ showData }: { showData: boolean }) => {
	const tradePreview = useAppSelector(selectCrossMarginTradePreview)
	const marketInfo = useAppSelector(selectV3SelectedMarketInfo)

	return (
		<FeeRows
			executionFee={showData ? wei(tradePreview?.settlementFee ?? 0) : undefined}
			tradeFee={showData ? wei(tradePreview?.fee ?? 0) : undefined}
			rates={{
				maker: wei(marketInfo?.feeRates.makerFee ?? 0),
				taker: wei(marketInfo?.feeRates.takerFee ?? 0),
			}}
		/>
	)
})

export default CrossMarginTradeFees
